// Sonave: shows an approximate price in the visitor's own currency next to
// the euro price (e.g. "≈ 975 Kč"). Checkout stays in EUR. The currency comes
// from the selected country, or from the language when the country uses the
// euro. Rates are the daily ECB reference rates, cached for 12 hours.
(function () {
  if (customElements.get('glow-local-price')) return;

  var root = document.documentElement;
  var RATES_URL = 'https://api.frankfurter.dev/v1/latest?base=EUR';
  var CACHE_KEY = 'glow-fx';
  var CACHE_MS = 12 * 60 * 60 * 1000;

  var COUNTRY_CURRENCY = {
    CZ: 'CZK', PL: 'PLN', HU: 'HUF', RO: 'RON', DK: 'DKK', SE: 'SEK', NO: 'NOK', IS: 'ISK',
    CH: 'CHF', LI: 'CHF', GB: 'GBP', US: 'USD', CA: 'CAD', MX: 'MXN', BR: 'BRL', AU: 'AUD',
    NZ: 'NZD', JP: 'JPY', KR: 'KRW', CN: 'CNY', HK: 'HKD', SG: 'SGD', MY: 'MYR', TH: 'THB',
    PH: 'PHP', ID: 'IDR', IN: 'INR', IL: 'ILS', TR: 'TRY', ZA: 'ZAR'
  };
  var LANGUAGE_CURRENCY = { cs: 'CZK', pl: 'PLN', hu: 'HUF', ro: 'RON', da: 'DKK', sv: 'SEK', nb: 'NOK', ja: 'JPY' };
  var HINT = {
    en: 'Approximate price in your currency. You pay in EUR.',
    cs: 'Přibližná cena ve vaší měně. Platíte v EUR.',
    sk: 'Približná cena vo vašej mene. Platíte v EUR.',
    pl: 'Przybliżona cena w Twojej walucie. Płacisz w EUR.',
    hu: 'Hozzávetőleges ár az Ön pénznemében. EUR-ban fizet.',
    ro: 'Preț aproximativ în moneda ta. Plătești în EUR.',
    da: 'Omtrentlig pris i din valuta. Du betaler i EUR.',
    sv: 'Ungefärligt pris i din valuta. Du betalar i EUR.',
    nb: 'Omtrentlig pris i din valuta. Du betaler i EUR.',
    de: 'Ungefährer Preis in Ihrer Währung. Sie zahlen in EUR.',
    fr: 'Prix approximatif dans votre devise. Vous payez en EUR.',
    it: 'Prezzo approssimativo nella tua valuta. Paghi in EUR.',
    es: 'Precio aproximado en tu moneda. Pagas en EUR.',
    nl: 'Geschatte prijs in je eigen valuta. Je betaalt in EUR.',
    ja: 'お客様の通貨での概算価格です。お支払いはユーロです。'
  };

  var locale = root.lang || 'en';
  var lang = locale.split('-')[0].toLowerCase();
  var activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
  var target = COUNTRY_CURRENCY[(root.dataset.glowCountry || '').toUpperCase()] || LANGUAGE_CURRENCY[lang];
  // Only add a second price when the shop shows euros and the visitor uses another currency.
  if (!target || (activeCurrency && activeCurrency !== 'EUR')) return;

  var ratesPromise;
  function getRate() {
    if (!ratesPromise) {
      ratesPromise = new Promise(function (resolve) {
        try {
          var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
          if (cached && cached.rates && Date.now() - cached.at < CACHE_MS) return resolve(cached.rates);
        } catch (e) {}
        fetch(RATES_URL)
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data || !data.rates) return resolve(null);
            try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), rates: data.rates })); } catch (e) {}
            resolve(data.rates);
          })
          .catch(function () { resolve(null); });
      });
    }
    return ratesPromise.then(function (rates) { return rates && rates[target]; });
  }

  function format(amount) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: target, maximumFractionDigits: 0 }).format(Math.round(amount));
    } catch (e) {
      return Math.round(amount) + ' ' + target;
    }
  }

  class GlowLocalPrice extends HTMLElement {
    connectedCallback() {
      var cents = parseInt(this.dataset.amount, 10);
      if (!cents) return;
      var el = this;
      getRate().then(function (rate) {
        if (!rate) return;
        el.textContent = '≈ ' + format((cents / 100) * rate);
        el.title = HINT[lang] || HINT.en;
        el.hidden = false;
      });
    }
  }

  customElements.define('glow-local-price', GlowLocalPrice);
})();
